angular.module('unergie.main')
.directive('userInfoContractSupervision', () =>
    ({
        restrict: 'E',
        templateUrl: '/states/userContractInfo/component/contract/userInfoContractSupervision.html',
    }),
)
